import React from "react";
import { Field } from "formik";
import { Row, Col } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";

const MixDesignIncludedTestResultDetail = ({ test, testIndex }) => {
  return (
    <>
      <Row>
        <div className="d-flex justify-content-between mb-0">
          <div className="d-flex mb-0">
            <label>Testing Parameters</label>
          </div>
        </div>
        <Col lg={12}>
          <div className="card mb-0" style={{ height: "auto" }}>
            <div className="card-body p-2">
              <Row>
                {test?.ReferenceStandardIDEncrypt && test?.ReferenceSubGroup ? (
                  <Col lg={6} style={{ marginTop: "-5px" }}>
                    <Field
                      type="text"
                      label="Group"
                      name={`ListOfMixDesignIncludedTest[${testIndex}].TestDetails.ReferenceSubGroup`}
                      component={CustomInput}
                      placeholder="Reference Sub Group"
                      // noMarginBottom={true}
                      disabled={true}
                    />
                  </Col>
                ) : (
                  ""
                )}
              </Row>
              <Row>
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-0">
                    <div
                      id="ParameterDetail-tbl_wrapper"
                      className="dataTables_wrapper table-responsive no-footer"
                    >
                      <table
                        id="ParameterDetail-tbl"
                        className="table table-bordered no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            {/* <th width="16%">Code</th> */}
                            <th width="16%">Parameter</th>
                            <th width="16%">Test Method</th>
                            {test?.ReferenceStandardIDEncrypt && (
                              <th width="15%">Range</th>
                            )}
                            {test?.ParameterWith == 2 && (
                              <>
                                <th width="9%">Min</th>
                                <th width="9%">Max</th>
                              </>
                            )}
                            {test?.ParameterWith == 3 && (
                              <th width="15%">Requirement</th>
                            )}
                            <th width="5%">NABL</th>
                            {test?.ListOfParameter[0]?.ListOfTestingResult?.map(
                              (result, rIdx) => (
                                <th
                                  width="15%"
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  {test?.ListOfParameter[0]?.ListOfTestingResult
                                    ?.length > 1
                                    ? result.TestingCountHeader
                                      ? result.TestingCountHeader
                                      : "S" + result.TestingCount
                                    : "Value"}
                                </th>
                              )
                            )}
                            {parseInt(test?.TestingQty) > 1 ? (
                              test?.ListOfParameter?.filter(
                                (x) => x.IsAverageRequired == true
                              )?.length > 0 ? (
                                <th
                                  width="5%"
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  Average
                                </th>
                              ) : (
                                ""
                              )
                            ) : (
                              ""
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {test?.ListOfParameter?.length > 0 ? (
                            test?.ListOfParameter?.map((para, pIndex) => (
                              <tr key={pIndex}>
                                {/* <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            {para.DisplayCode}
                                                          </td> */}
                                <td
                                  className="p-1"
                                  style={{
                                    minWidth: "100px",
                                  }}
                                >
                                  {para.ParameterName}
                                  {para.ShortCode ? (
                                    <>
                                      &nbsp;(
                                      <span className="text-primary">
                                        <b>{para.ShortCode}</b>
                                      </span>
                                      )
                                    </>
                                  ) : (
                                    ""
                                  )}
                                  {para.FormulaExpression ? (
                                    <>
                                      &nbsp;
                                      <i
                                        className="custom-fa"
                                        title={para.FormulaExpression}
                                      >
                                        &#x0192;x
                                      </i>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td
                                  className="p-1"
                                  style={{
                                    minWidth: "100px",
                                  }}
                                >
                                  {para.TestMethod}
                                </td>
                                {test?.ReferenceStandardIDEncrypt && (
                                  <td
                                    className="p-1"
                                    style={{
                                      minWidth: "100px",
                                    }}
                                  >
                                    {para?.RangeValue && (
                                      <Field
                                        name={`ListOfMixDesignIncludedTest[${testIndex}].TestDetails.ListOfParameter[${pIndex}].RangeValue`}
                                        placeholder={"Range Value"}
                                        component={CustomInput}
                                        noMarginBottom={true}
                                        disabled={true}
                                      />
                                    )}
                                  </td>
                                )}

                                {test?.ParameterWith == 2 && (
                                  <>
                                    <td
                                      className="p-1"
                                      style={{
                                        minWidth: "80px",
                                      }}
                                    >
                                      <Field
                                        type="number"
                                        name={`ListOfMixDesignIncludedTest[${testIndex}].TestDetails.ListOfParameter[${pIndex}].MinValue`}
                                        component={CustomInput}
                                        placeholder="Min"
                                        maxLength={50}
                                        noMarginBottom={true}
                                        disabled={true}
                                      />
                                    </td>
                                    <td
                                      className="p-1"
                                      style={{
                                        minWidth: "80px",
                                      }}
                                    >
                                      <Field
                                        type="number"
                                        name={`ListOfMixDesignIncludedTest[${testIndex}].TestDetails.ListOfParameter[${pIndex}].MaxValue`}
                                        component={CustomInput}
                                        placeholder="Max"
                                        maxLength={50}
                                        noMarginBottom={true}
                                        disabled={true}
                                      />
                                    </td>
                                  </>
                                )}
                                {test?.ParameterWith == 3 && (
                                  <td
                                    className="p-1"
                                    style={{
                                      minWidth: "100px",
                                    }}
                                  >
                                    <Field
                                      type="text"
                                      name={`ListOfMixDesignIncludedTest[${testIndex}].TestDetails.ListOfParameter[${pIndex}].Requirement`}
                                      component={CustomInput}
                                      placeholder="Requirement"
                                      maxLength={500}
                                      noMarginBottom={true}
                                      disabled={true}
                                    />
                                  </td>
                                )}
                                <td>
                                  <label
                                    title={
                                      para.NABLRangeFrom
                                        ? para.NABLRangeFrom +
                                          " - " +
                                          para.NABLRangeTo
                                        : ""
                                    }
                                  >
                                    {para.IsNABLParameter ? "Yes" : "No"}
                                    &nbsp;
                                    {para?.ParameterType == 1
                                      ? para?.ParameterResultType == 2
                                        ? "(QL)"
                                        : "(QN)"
                                      : ""}
                                  </label>
                                </td>
                                {para?.ListOfTestingResult?.map(
                                  (result, rIdx) => (
                                    <td
                                      className="p-1"
                                      style={{
                                        textAlign: "left",
                                        minWidth: "100px",
                                      }}
                                    >
                                      <div className="d-flex justify-content-between">
                                        <div
                                          className="pe-1"
                                          style={{
                                            width: "90%",
                                          }}
                                        >
                                          <Field
                                            type="text"
                                            name={`ListOfMixDesignIncludedTest[${testIndex}].TestDetails.ListOfParameter[${pIndex}].ListOfTestingResult[${rIdx}].ResultValue`}
                                            component={CustomInput}
                                            placeholder="Value"
                                            maxLength={500}
                                            noMarginBottom={true}
                                            disabled={true}
                                          />
                                        </div>
                                        <div
                                          style={{
                                            alignContent: "center",
                                          }}
                                        >
                                          {test?.ReferenceStandardIDEncrypt && (
                                            <>
                                              {result?.ConsiderResult == 0 ? (
                                                <i
                                                  className="fa fa-circle"
                                                  style={{
                                                    color: "red",
                                                  }}
                                                ></i>
                                              ) : result.ConsiderResult == 1 ? (
                                                <i
                                                  className="fa fa-circle"
                                                  style={{
                                                    color: "green",
                                                  }}
                                                ></i>
                                              ) : result.ConsiderResult ==
                                                -1 ? (
                                                <i
                                                  className="fa fa-circle"
                                                  style={{
                                                    color: "orange",
                                                  }}
                                                ></i>
                                              ) : (
                                                <i className="fa fa-circle"></i>
                                              )}
                                              <br></br>
                                            </>
                                          )}
                                          {para?.IsNABLParameter == true ? (
                                            <>
                                              {result?.ConsiderNABLResult ==
                                              0 ? (
                                                <i
                                                  className="fa fa-certificate"
                                                  style={{
                                                    color: "red",
                                                  }}
                                                ></i>
                                              ) : result.ConsiderNABLResult ==
                                                1 ? (
                                                <i
                                                  className="fa fa-certificate"
                                                  style={{
                                                    color: "green",
                                                  }}
                                                ></i>
                                              ) : result.ConsiderNABLResult ==
                                                -1 ? (
                                                <i
                                                  className="fa fa-certificate"
                                                  style={{
                                                    color: "orange",
                                                  }}
                                                ></i>
                                              ) : (
                                                <i className="fa fa-certificate"></i>
                                              )}
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                    </td>
                                  )
                                )}
                                {parseInt(test?.TestingQty) > 1 ? (
                                  test?.ListOfParameter?.filter(
                                    (x) => x.IsAverageRequired == true
                                  )?.length > 0 ? (
                                    <td
                                      className="p-1"
                                      style={{
                                        textAlign: "left",
                                        minWidth: "80px",
                                      }}
                                    >
                                      {para.IsAverageRequired == true && (
                                        <Field
                                          type="text"
                                          name={`ListOfMixDesignIncludedTest[${testIndex}].TestDetails.ListOfParameter[${pIndex}].AverageResultValue`}
                                          component={CustomInput}
                                          placeholder="Average"
                                          maxLength={50}
                                          disabled={true}
                                          noMarginBottom={true}
                                        />
                                      )}
                                    </td>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  ""
                                )}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan={8}
                                style={{
                                  textAlign: "left",
                                }}
                              >
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default MixDesignIncludedTestResultDetail;
